import React from "react";
import numeral from "numeral";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { format } from "date-fns";

const styles = StyleSheet.create({
  page: {
    // backgroundColor: '#ffffff',
    // marginRight: 50,
    // paddingBottom: 60,
    // marginTop: 60,
    // paddingLeft: 50,
  },
  body: {
    paddingRight: 50,
    paddingTop: 70,
    paddingLeft: 50,
  },
  company_name: {
    Font: "helvetica",
    fontWeight: 500,
    fontSize: 9,
  },

  company_namehead: {
    Font: "helvetica",
    fontWeight: 800,
    fontSize: 10,
  },

  company_namecheck: {
    Font: "helvetica",
    fontWeight: 900,
    fontSize: 14,
  },
  computationsText: {
    Font: "Arial",
    fontWeight: 900,
    fontSize: 10,
  },

  company_nameWidth: {
    Font: "helvetica",
    fontWeight: 500,
    fontSize: 9,
    maxWidth: 240,
  },

  company_nameCheck: {
    Font: "helvetica",
    fontWeight: 600,
  },

  package: {
    Font: "Arial",
    fontWeight: 900,
    fontSize: 9,
    width: 100,
  },
  company_adress: {
    Font: "Arial",
    fontWeight: 700,
    fontSize: 9,
  },
  padding: {
    padding: 1,
  },
  paddingTop10: {
    paddingTop: 13,
  },
  paddingTop20: {
    paddingRight: 40,
  },
  paddingTop5: {
    paddingTop: 4,
  },

  paddingTop8: {
    paddingTop: 9,
  },

  paddingBtm10: {
    paddingBottom: 10,
  },

  paddingBtm20: {
    paddingBottom: 70,
  },
  cell: {
    marginRight: 50,
  },
  cellRight: {
    textAlign: "right",
  },
  cellLeft: {
    textAlign: "left",
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
  },
  col1: {
    display: "flex",
    flexDirection: "row",
    width: 70,
  },

  paymentInfoText: {
    Font: "Roboto",
    fontWeight: 500,
    fontSize: 10,
  },

  paymentInfoCol: {
    display: "flex",
    flexDirection: "row",
    width: 100,
    maxWidth: 100,
  },

  rowWidth: {
    width: "100%",
  },
  col50: {
    width: "50%",
  },
  col45: {
    width: "45%",
  },
  col2: {
    display: "flex",
    flexDirection: "row",
    width: 320,
  },
  col3: {
    display: "flex",
    flexDirection: "row",
    width: 100,
  },
  col4: {
    display: "flex",
    flexDirection: "row",
    width: 100,
    border: 1,
  },
  col5: {
    display: "flex",
    flexDirection: "row",
    width: 100,
    border: 1,
  },
  floatright: {
    alignItems: "flex-end",
  },
  colComputations1: {
    width: 100,
  },
  colComputations2: {
    width: 100,
  },
  row: {
    display: "flex",
    flexDirection: "row",
  },
  textcenter: {
    textAlign: "center",
  },
  textleft: {
    textAlign: "left",
  },
  textRight: {
    textAlign: "right",
  },
  border: {
    borderBottom: 1,
  },
  borderAll: {
    border: 1,
  },
  borderTop: {
    borderTop: 1,
    minWidth: 90,
  },
  boldFont: {
    fontWeight: 980,
  },
  fontSize11: {
    fontSize: 11,
    fontWeight: 800,
  },
  textCenter: {
    alignItems: "center",
  },
  alignCenter: {
    display: "flex",
    flexDirection: "row",
  },
  marginRight10: {
    marginRight: "10%",
  },
  marginRight3: {
    marginRight: "3%",
  },
  paddingLeft: {
    paddingLeft: 450,
  },
  paddingLeftcheck: {
    paddingLeft: 30,
  },
  marginTopt10: {
    paddingTop: "10%",
  },
  pageNumbers: {
    position: "absolute",
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 6,
  },

  check: {
    position: "absolute",
    bottom: 0,
    left: 40,
    right: 0,
    fontSize: 9,
  },

  checkDate: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 2,
    fontSize: 9,
    textAlign: "right",
  },

  checkBtmDate: {
    fontSize: 10,
    paddingRight:8,
    position: "absolute",
    bottom: 3,
    left: 0,
    right: 0,
    textAlign: "right",
  },

  // borderTop: {
  //     border: 1,
  // },
  tableBox: {
    minHeight: 380,
  },

  checkMarginTop: {
    marginBottom:20,
    paddingLeft:55,
    fontSize: 10,
    fontWeight: 600,
    marginLeft: 9,
  },
  printHeader: {
    flexDirection: "row",
    textAlign: "center",
    fontSize: 9,
  },
  printBtm: {
    flexDirection: "row",
    textAlign: "center",
    fontSize: 10,
  },
  left: {
    alignItems: "flex-start",
    minWidth: 250,
    textAlign: "left",

    marginLeft: 30,
  },
  right: {
    fontSize: 10,
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    textAlign: "right",
    marginRight: 25,
  },
});

const applyMultipleEdits = (str, edits) => {
  let result = str;
  // console.log(str);
  // console.log(str.length);
  edits.forEach((edit) => {
    const { index, addition } = edit;
    if (result && index >= 0 && index < result.length) {
      result = result.slice(0, index) + addition + result.slice(index);
    }
  });

  return result;
};
const edits = [
  { index: 2, addition: "" },
  
  { index: 4, addition: "   " },
  { index: 20, addition: " " },
  // { index: 21, addition: "--" },
  { index: 25, addition: " " },
  { index: 27, addition: " " },
  { index: 30, addition: " " },
  { index: 35, addition: " " },
];
export function PdfDocumentMashreq({ headers, items }) {
  return (
    <Document>
      <Page size="letter" style={styles.page} orientation="portrait" wrap>
        <View style={styles.body}>
          <View
            style={[
              styles.printHeader,
              styles.marginTopt10,
              styles.paddingBtm20,
            ]}
          >
            <Text style={[styles.company_namehead, styles.company_nameWidth]}>
              {headers.supname}
            </Text>
            <Text style={styles.company_namehead}>{headers.check_date}</Text>
          </View>

          <View style={[styles.section, styles.paddingBtm10]}>
            {/* HEADER SECTION DUBAI */}
            <Text style={styles.company_name}>Pay To:{headers.supname}</Text>
            <Text style={styles.company_name}>
              Check Date:{headers.check_date}
            </Text>
            <Text style={styles.company_name}>
              Check Amount:{headers.checkamt}
            </Text>
          </View>
          <View style={[styles.tableBox]}>
            {/* Item Details */}
            <View style={[styles.tableRow, styles.paddingTop10]}>
              <View
                style={[
                  styles.tableRow,
                  styles.col1,
                  styles.cellLeft,
                  styles.marginRight3,
                ]}
              >
                <Text
                  style={[
                    styles.company_adress,
                    styles.cellLeft,
                    styles.boldFont,
                  ]}
                >
                  Transaction Date
                </Text>
              </View>
              <View style={[styles.tableRow, styles.col2, styles.cellLeft]}>
                <Text
                  style={[
                    styles.company_adress,
                    styles.cellLeft,
                    styles.boldFont,
                  ]}
                >
                  Details
                </Text>
              </View>
              <View style={[styles.tableRow, styles.col3, styles.cellRight]}>
                <Text
                  style={[
                    styles.company_adress,
                    styles.cellRight,
                    styles.boldFont,
                  ]}
                >
                  Amount
                </Text>
              </View>
            </View>

            {!items == ""
              ? items.map((row, ind) => (
                  <View style={[styles.tableRow]}>
                    <View
                      style={[
                        styles.tableRow,
                        styles.col1,
                        styles.marginRight3,
                      ]}
                    >
                      <Text
                        style={[
                          styles.company_adress,
                          styles.cellLeft,
                          styles.padding,
                        ]}
                      >
                        {items[ind].chkdate}
                      </Text>
                    </View>
                    <View style={[styles.tableRow, styles.col2]}>
                      <Text
                        style={[
                          styles.company_adress,
                          styles.cellLeft,
                          styles.padding,
                        ]}
                      >
                        {items[ind].description}
                      </Text>
                    </View>
                    <View style={[styles.tableRow, styles.col3]}>
                      <Text
                        style={[
                          styles.company_adress,
                          styles.cellRight,
                          styles.padding,
                        ]}
                      >
                        {numeral(items[ind].amount).format("0,0.00")}
                      </Text>
                    </View>
                  </View>
                ))
              : null}

            <View style={[styles.tableRow, styles.marginTopt10]}>
              <View
                style={[
                  styles.tableRow,
                  styles.col1,
                  styles.cell,
                  styles.borderTop,
                ]}
              >
                <Text
                  style={[
                    styles.company_adress,
                    styles.boldFont,
                    styles.paddingTop5,
                  ]}
                >
                  Prepared By:
                </Text>
              </View>
              <View
                style={[
                  styles.tableRow,
                  styles.col1,
                  styles.cell,
                  styles.borderTop,
                ]}
              >
                <Text
                  style={[
                    styles.company_adress,
                    styles.boldFont,
                    styles.paddingTop5,
                  ]}
                >
                  Checked By:
                </Text>
              </View>
              <View
                style={[
                  styles.tableRow,
                  styles.col1,
                  styles.cell,
                  styles.borderTop,
                ]}
              >
                <Text
                  style={[
                    styles.company_adress,
                    styles.boldFont,
                    styles.paddingTop5,
                  ]}
                >
                  Approved By:
                </Text>
              </View>
              <View
                style={[
                  styles.tableRow,
                  styles.col1,
                  styles.cell,
                  styles.borderTop,
                ]}
              >
                <Text
                  style={[
                    styles.company_adress,
                    styles.boldFont,
                    styles.paddingTop5,
                  ]}
                >
                  Audited By:
                </Text>
              </View>
            </View>
          </View>
          <View>
            <Text style={[styles.checkBtmDate,styles.paddingLeftcheck,{position:'relative',bottom:25}]}>
              {format(new Date(headers.check_date), "dd - MMM - yyyy")}
            </Text>
          </View>

   
          <View style={[styles.checkMarginTop,{position:'relative',bottom:5,}]}>
            <Text style={[styles.company_nameCheck]}>
              {headers.supname}
            </Text>
          </View>

          <View style={[styles.printBtm,{position:'relative',bottom:0,left:20,alignItems:'center',alignContent:'space-between',width:'100%'}]}>
            <Text style={[styles.company_nameCheck, styles.left]}>{headers.checkTextAmt}</Text>
            <Text
              style={[
                styles.company_nameCheck,
                styles.right,
                styles.paddingLeftcheck,
              ]}
            >
                          {headers.checkamt}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
}
